import { useQuery } from "react-query";
import { checkIfUserEligible } from "../services/api";
import { isUserLoggedIn } from "../utils/helpers";

export const useIfUserEligible = (feature, options = {}) => {
  // Optional flags you can pass from the component
  const { explorePage = false } = options;

  const shouldEnableQuery =
    !!feature && (!explorePage || (explorePage && isUserLoggedIn()));

  const {
    data,
    isLoading: isCheckingEligibility,
    refetch: checkFeatureEligibility,
  } = useQuery(
    ["userEligibility", feature],
    () => checkIfUserEligible(feature),
    {
      enabled: shouldEnableQuery, // <---- this prevents API call
      refetchOnWindowFocus: true,
      select: (response) => ({
        isEligible: response.data.data.allowed,
        requiredSubscription: response.data.data.required_subscription_tier,
        subscription:
          response.data.data.required_subscription_tier_name || "Premium",
        remainingTokens: response.data.data?.extra_data?.remaining_limit || 0,
        isAppropriateSubscription:
          response.data.data?.extra_data?.appropriate_sub,
        isInReferralProgram: response.data.data?.extra_data?.in_ref_program,
      }),
    }
  );

  return {
    isEligible: data?.isEligible ?? true,
    subscription: data?.subscription ?? "Premium",
    requiredSubscription: data?.requiredSubscription,
    isCheckingEligibility,
    checkFeatureEligibility,
    remainingTokens: data?.remainingTokens ?? 0,
    isAppropriateSubscription: data?.isAppropriateSubscription ?? false,
    isInReferralProgram: data?.isInReferralProgram ?? false,
  };
};
